import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Sign-in landing page. Kicks the user off to Emergent's hosted Google OAuth flow.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function Login() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) navigate("/", { replace: true });
  }, [user, loading, navigate]);

  const handleGoogleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <div className="min-h-screen w-full bg-zinc-50 flex items-center justify-center px-6" data-testid="login-page">
      <div className="max-w-md w-full bg-white border border-zinc-200 p-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 bg-[#002FA7] flex items-center justify-center">
            <span className="text-white font-bold text-sm tracking-wider">ROC</span>
          </div>
          <div>
            <div className="font-heading text-xl tracking-tight">ROC Vault</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">
              MCA Compliance · India
            </div>
          </div>
        </div>

        <h1 className="font-heading text-3xl font-light tracking-tight mb-3">
          Welcome back.
        </h1>
        <p className="text-sm text-zinc-600 mb-8 leading-relaxed">
          Sign in with your Google account to access your firm's companies, board resolutions,
          compliance calendar, and statutory filings.
        </p>

        <button
          onClick={handleGoogleSignIn}
          className="w-full flex items-center justify-center gap-3 border border-zinc-300 px-4 py-3 hover:bg-zinc-50 transition-colors font-medium text-sm"
          data-testid="google-signin-button"
        >
          <GoogleMark />
          Continue with Google
        </button>

        <p className="text-[11px] text-zinc-500 mt-6 leading-relaxed">
          By signing in you agree to use ROC Vault for legitimate Indian Companies Act 2013
          compliance work. Sessions last 7 days.
        </p>
      </div>
    </div>
  );
}

function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.71v2.25h2.91c1.7-1.57 2.69-3.88 2.69-6.6z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.81 5.96-2.19l-2.91-2.26c-.81.54-1.84.86-3.05.86-2.34 0-4.32-1.58-5.03-3.71H.96v2.33A9 9 0 0 0 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.97 10.7A5.41 5.41 0 0 1 3.68 9c0-.59.1-1.16.29-1.7V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.04l3.01-2.34z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.96L3.97 7.3C4.68 5.16 6.66 3.58 9 3.58z"
      />
    </svg>
  );
}
